import { cannotDeletePartnerDestination, duplicateTrackingId, googleAccountsResetPasswordError, phoneError, scanRegisteredTaskUnassigned, shopifyPartnerCodeMissed, wrondPolybagId, } from '../constants/errors';
export var errors = {
    phoneError: "Variable 'phone' has an invalid value",
    existAccount: 'An account with the given email already exists.',
    existGoogleAccount: 'PreSignUp failed with error EXISTING_GOOGLE_ACCOUNT.',
    isNotExistUser: 'User does not exist.',
    verificationCode: 'Invalid verification code provided, please try again.',
    cannotResetPassword: 'Cannot reset password for the user as there is no registered/verified email or phone_number',
    userNotFound: 'UserNotFoundException: User does not exist.',
    signInAttemptsExceeded: 'Password attempts exceeded',
    incorrectCombination: 'Incorrect username or password.',
    incorrectClientCombination: 'Username/client id combination not found.',
    polybagNotFound: 'polybag not found',
};
function errorMapper(err) {
    if (typeof err !== 'string') {
        return err;
    }
    switch (err) {
        case errors.phoneError:
            return phoneError;
        case errors.existAccount:
            return 'An account already exists with this email';
        case errors.existGoogleAccount:
            return 'An account exists with this email. If you previously created your account using Google, use "Sign up with Google"';
        case errors.isNotExistUser:
            return 'Incorrect email or password';
        case errors.verificationCode:
            return 'Invalid verification code';
        case errors.cannotResetPassword:
            return 'We cannot reset password for this email';
        case errors.userNotFound:
            return "We're unable to update your password. If you signed in with Google, please visit Google.com";
        case errors.signInAttemptsExceeded:
            return 'Sign-in limit exceeded. Please wait 15 minutes and try again';
        case errors.incorrectCombination:
            return 'Invalid username or password';
        case errors.incorrectClientCombination:
            return googleAccountsResetPasswordError;
        case errors.polybagNotFound:
            return wrondPolybagId;
        default:
            if (err.match(/Variable 'phone' has an invalid value. Unable to parse `\(\d\d\d\) \d\d\d-\d\d\d\d` as a valid phone number./)) {
                return phoneError;
            }
            if (err.match(/ERROR: duplicate key value violates unique constraint \\+"package_tracking_id_idx\\+"\\+n {2}Detail: Key \(tracking_id\)=\(([-\w]+)\) already exists/)) {
                return duplicateTrackingId;
            }
            if (err.match('update or delete on table "partner_destination" violates foreign key constraint "consolidation_partner_destination_id_fkey" on table "consolidation"')) {
                return cannotDeletePartnerDestination;
            }
            if (err.match(/Missing task\/worker for package with tracking ([\w-]+)\. Trip scheduled for ([\w\s-]+) on (\d{2}\/\d{2}\/\d{4})/)) {
                return scanRegisteredTaskUnassigned;
            }
            if (err === 'Variable "$code" of required type "String!" was not provided.') {
                return shopifyPartnerCodeMissed;
            }
            return err;
    }
}
export default errorMapper;
//# sourceMappingURL=errorMapper.js.map